export const SET_ACCOUNT_SETTINGS_THIRD_PAGE_VIEW = 'SET_ACCOUNT_SETTINGS_THIRD_PAGE_VIEW';
